import ShellHeader from '../components/ShellHeader';

const serviceHighlights = [
  {
    title: 'MOT Testing',
    strapline: 'Class 4 cars and Class 7 vans',
    description:
      'Experienced MOT testing to help keep your vehicle safe and road legal.',
    points: [
      'Annual MOT testing for eligible vehicles',
      'Class 4 cars and Class 7 vans',
      'Call for availability and advice',
    ],
  },
  {
    title: 'Servicing',
    strapline: 'Competitive prices',
    description:
      'Routine servicing helps reduce future repair costs and keep your car running well.',
    points: [
      'Reduced repair costs over time',
      'Lower risk of breakdowns',
      'Improved safety and fuel economy',
    ],
  },
  {
    title: 'Brakes',
    strapline: 'Check your brakes',
    description:
      'Brake parts supplied and fitted for all makes and models.',
    points: [
      'Pads, discs, calipers and brake pipes',
      'Checks for juddering, squealing or grinding',
      'Advice if the vehicle pulls under braking',
    ],
  },
  {
    title: 'Diagnostics',
    strapline: 'Identify the problem',
    description:
      'We diagnose warning lights and electronic faults across modern vehicle systems.',
    points: [
      'Dashboard warning light investigation',
      'Electronic fault finding',
      'ABS and safety system checks',
    ],
  },
  {
    title: 'Tyres',
    strapline: 'Replacing your tyres',
    description:
      'Tyre advice and checks to keep you safe and legal on the road.',
    points: [
      'Cuts, cracks, bulges and wear checked',
      'Friendly expert advice',
      'Free tyre check available',
    ],
  },
  {
    title: 'Air Conditioning',
    strapline: 'Air con recharge',
    description:
      'Air con recharge support for vehicles that are no longer cooling as they should.',
    points: [
      'Air con performance checks',
      'Recharge support for older vehicles',
      'Helps restore cooling efficiency',
    ],
  },
  {
    title: 'Suspension',
    strapline: 'Safety and comfort',
    description:
      'Suspension checks for safety, handling and ride comfort.',
    points: [
      'Checks for worn shock absorbers',
      'Diagnosis of knocks and handling issues',
      'Advice on repair requirements',
    ],
  },
  {
    title: 'Batteries',
    strapline: 'Fitted while you wait',
    description:
      'A wide range of batteries available with while-you-wait fitting.',
    points: [
      'Extensive battery stock',
      'Fast fitting available',
      'Multiple warranty options',
    ],
  },
];

function ServicingPage({ authUser }) {
  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />

      <main className="content-wrap about-content-wrap servicing-content-wrap">
        <div className="servicing-main-column">
          <section className="content-page-block about-page-main servicing-intro-block">
            <div className="section-header">
              <h2>Servicing</h2>
            </div>

            <p>
              M.J. Motors offer a full range of workshop services including MOT testing,
              servicing, brakes, diagnostics, tyres, air conditioning, suspension and batteries.
            </p>

            <p>
              For availability or to discuss a problem with your vehicle, call us on{' '}
              <a className="servicing-phone-link" href="tel:01782835561">01782 835 561</a>.
            </p>
          </section>

          <section className="content-page-block servicing-services-block">
            <div className="section-header servicing-services-header">
              <h3>Workshop Services</h3>
            </div>

            <div className="servicing-services-grid">
              {serviceHighlights.map((service) => (
                <article key={service.title} className="servicing-service-card">
                  <div className="servicing-service-heading">
                    <h4>{service.title}</h4>
                    <span>{service.strapline}</span>
                  </div>
                  <p>{service.description}</p>
                  <ul className="servicing-service-points">
                    {service.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </section>
        </div>

        <aside className="about-page-sidebar" aria-label="Servicing details">
          <section className="content-page-block about-side-panel servicing-side-panel">
            <h3 className="about-side-title">Contact Us</h3>
            <a className="about-contact-link" href="tel:01782835561">01782 835561</a>
            <a className="about-contact-link" href="mailto:markjeffery1000@yahoo.co.uk">
              Email Us
            </a>
          </section>

          <section className="content-page-block about-side-panel servicing-side-panel">
            <h3 className="about-side-title">What We Cover</h3>
            <p className="about-contact-text">
              MOT testing, servicing, brakes, diagnostics, tyres, air conditioning, suspension
              and batteries.
            </p>
          </section>

          <section className="content-page-block about-side-panel servicing-side-panel">
            <h3 className="about-side-title">Visit Us</h3>
            <p className="about-contact-text">
              M.J. Motors
              <br />
              Summerbank Service Station
              <br />
              High Street
              <br />
              Stoke-on-Trent
              <br />
              Staffordshire
              <br />
              ST6 5ET
            </p>
          </section>
        </aside>
      </main>
    </div>
  );
}

export default ServicingPage;